import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { Button } from 'LocalGluons';
import styles from './EditSelectBarTablet.jss';

const editButtonStyle = {
    button: styles.buttonButton,
    icon: styles.buttonIcon,
    text: styles.buttonText,
    textContainer: styles.buttonTextContainer
};

const selectAllButtonStyle = {
    button: styles.toggleButton,
    icon: styles.buttonIcon,
    textContainer: styles.buttonTextContainerSelectAll
};

const EditSelectBarTablet = ({
    editing,
    loading,
    refreshing,
    allCheckbox,
    selectAll,
    startEditing
}) => (
    <View style={styles.editContainer}>
        {editing && !loading && !refreshing ? (
            <>
                <Text style={styles.categoryTitle}>{t('RECORDINGS.MY_RECORDINGS')}</Text>
                {allCheckbox ? (
                    <Button
                        onPress={selectAll}
                        iconName="checkmark"
                        title={t('COMMON.DESELECT_ALL')}
                        style={selectAllButtonStyle}
                        isSecondary
                    />
                ) : (
                    <Button
                        onPress={selectAll}
                        iconName="checkmark"
                        title={t('COMMON.SELECT_ALL')}
                        style={selectAllButtonStyle}
                        isSecondary
                        testID="select_all_button"
                    />
                )}
            </>
        ) : (
            <>
                <Text style={styles.categoryTitle}>{t('RECORDINGS.MY_RECORDINGS')}</Text>
                <Button
                    onPress={startEditing}
                    iconName="edit"
                    style={editButtonStyle}
                    isSecondary
                    testID="edit_button"
                />
            </>
        )}
    </View>
);

EditSelectBarTablet.propTypes = {
    editing: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    refreshing: PropTypes.bool.isRequired,
    allCheckbox: PropTypes.bool.isRequired,
    selectAll: PropTypes.func.isRequired,
    startEditing: PropTypes.func.isRequired
};

export default EditSelectBarTablet;
